import { useImsApiContext } from '@/auth/ImsApiContext';

// Read a per-user feature flag resolved at login. Fails CLOSED: an unknown flag, flags
// that never loaded, or a ui-proxy error all read as false so an unreleased feature can't leak.
export const useFeatureFlag = (name: string): boolean =>
	useImsApiContext()?.featureFlags?.[name] ?? false;
